// Custom Report Field definitions based on backend enum
export const CUSTOM_REPORT_FIELDS = [
  // Ticket basic fields
  {
    fieldId: 'TICKET_ID',
    displayName: 'ID do Ticket',
    fieldName: 'id',
    dataType: 'number',
    hasJoin: false
  },
  {
    fieldId: 'TICKET_CODE',
    displayName: 'Nº Ticket',
    fieldName: 'code',
    dataType: 'number',
    hasJoin: false
  },
  {
    fieldId: 'TICKET_SUBJECT',
    displayName: 'Assunto',
    fieldName: 'subject',
    dataType: 'text',
    hasJoin: false
  },
  {
    fieldId: 'TICKET_STATUS',
    displayName: 'Status',
    fieldName: 'status',
    dataType: 'text',
    hasJoin: true,
    isEnum: true
  },
  {
    fieldId: 'TICKET_PRIORITY',
    displayName: 'Prioridade',
    fieldName: 'priority',
    dataType: 'text',
    hasJoin: true,
    isEnum: true
  },

  // Relationships with joins
  {
    fieldId: 'TICKET_REQUESTER',
    displayName: 'Contato',
    fieldName: 'contact.name',
    dataType: 'text',
    hasJoin: true
  },
  {
    fieldId: 'TICKET_CUSTOMER',
    displayName: 'Cliente',
    fieldName: 'customer.name',
    dataType: 'text',
    hasJoin: true
  },
  {
    fieldId: 'TICKET_ASSIGNEE',
    displayName: 'Agente',
    fieldName: 'agent.firstName',
    dataType: 'text',
    hasJoin: true
  },
  {
    fieldId: 'TICKET_SERVICE_GROUP',
    displayName: 'Grupo de Serviço',
    fieldName: 'serviceGroup.name',
    dataType: 'text',
    hasJoin: true
  },
  {
    fieldId: 'TICKET_SERVICE_CATALOG',
    displayName: 'Catálogo de Serviço',
    fieldName: 'serviceCatalog.name',
    dataType: 'text',
    hasJoin: true
  },

  // More ticket fields
  {
    fieldId: 'TICKET_TYPE',
    displayName: 'Tipo de Ticket',
    fieldName: 'typeTicket.name',
    dataType: 'text',
    hasJoin: true
  },
  {
    fieldId: 'TICKET_CREATED_AT',
    displayName: 'Data de Criação',
    fieldName: 'creationDate',
    dataType: 'datetime',
    hasJoin: false
  },
  {
    fieldId: 'TICKET_COMPLETED_AT',
    displayName: 'Data de Conclusão',
    fieldName: 'solutionDate',
    dataType: 'datetime',
    hasJoin: false
  },
  {
    fieldId: 'TICKET_CLOSED_AT',
    displayName: 'Data de Fechamento',
    fieldName: 'closedDate',
    dataType: 'datetime',
    hasJoin: false
  },
  {
    fieldId: 'TICKET_DELETED_AT',
    displayName: 'Data de Exclusão',
    fieldName: 'deletedDate',
    dataType: 'datetime',
    hasJoin: false
  },
  {
    fieldId: 'TICKET_STATUS_SLA_RESPONSE',
    displayName: 'Status SLA Resposta',
    fieldName: 'statusSlaResponse',
    dataType: 'text',
    hasJoin: false,
    isEnum: true
  },
  {
    fieldId: 'TICKET_STATUS_SLA_SOLUTION',
    displayName: 'Status SLA Solução',
    fieldName: 'statusSlaSolution',
    dataType: 'text',
    hasJoin: false,
    isEnum: true
  },
  {
    fieldId: 'TICKET_PERCENTAGE_SLA_RESPONSE',
    displayName: 'Percentual SLA Resposta',
    fieldName: 'percentageSlaResponse',
    dataType: 'number',
    hasJoin: false
  },
  {
    fieldId: 'TICKET_PERCENTAGE_SLA_SOLUTION',
    displayName: 'Percentual SLA Solução',
    fieldName: 'percentageSlaSolution',
    dataType: 'number',
    hasJoin: false
  },
  {
    fieldId: 'TICKET_RESPONSE_TIME',
    displayName: 'Data de Vencimento SLA Resposta',
    fieldName: 'responseSlaExpiration',
    dataType: 'datetime',
    hasJoin: false
  },
  {
    fieldId: 'TICKET_RESOLUTION_TIME',
    displayName: 'Data de Vencimento SLA Solução',
    fieldName: 'solutionSlaExpiration',
    dataType: 'datetime',
    hasJoin: false
  },
  {
    fieldId: 'TICKET_SOURCE_CHANNEL',
    displayName: 'Canal de Origem',
    fieldName: 'origin',
    dataType: 'text',
    hasJoin: true,
    isEnum: true
  },
  {
    fieldId: 'TICKET_ASSET',
    displayName: 'Ativo',
    fieldName: 'asset.name',
    dataType: 'text',
    hasJoin: true
  },
  {
    fieldId: 'TICKET_DELETED',
    displayName: 'Excluído',
    fieldName: 'deleted',
    dataType: 'boolean',
    hasJoin: false
  },
  {
    fieldId: 'TICKET_PAUSE_COUNT',
    displayName: 'Quantidade de apontamentos',
    fieldName: 'pauses.size',
    dataType: 'number',
    hasJoin: false
  },
  {
    fieldId: 'TICKET_PAUSE_TOTAL_HOURS',
    displayName: 'Total de horas apontadas',
    fieldName: 'totalHours',
    dataType: 'duration',
    hasJoin: false
  },
  {
    fieldId: 'TICKET_PAUSE_INTERNAL_HOURS',
    displayName: 'Total de horas internas',
    fieldName: 'internalHours',
    dataType: 'duration',
    hasJoin: false
  },
  {
    fieldId: 'TICKET_PAUSE_EXTERNAL_HOURS',
    displayName: 'Total de horas externas',
    fieldName: 'externalHours',
    dataType: 'duration',
    hasJoin: false
  }
];

// Operators based on data type
export const FIELD_OPERATORS = {
  text: [
    { value: 'EQUALS', label: 'É igual a' },
    { value: 'NOT_EQUALS', label: 'Diferente de' },
    { value: 'CONTAINS', label: 'Contém' },
    { value: 'NOT_CONTAINS', label: 'Não contém' },
    { value: 'STARTS_WITH', label: 'Começa com' },
    { value: 'ENDS_WITH', label: 'Termina com' },
    { value: 'IS_NULL', label: 'Está vazio' },
    { value: 'IS_NOT_NULL', label: 'Não está vazio' }
  ],
  number: [
    { value: 'EQUALS', label: 'Igual a' },
    { value: 'NOT_EQUALS', label: 'Diferente de' },
    { value: 'GREATER_THAN', label: 'Maior que' },
    { value: 'GREATER_THAN_OR_EQUAL', label: 'Maior ou igual a' },
    { value: 'LESS_THAN', label: 'Menor que' },
    { value: 'LESS_THAN_OR_EQUAL', label: 'Menor ou igual a' },
    { value: 'IS_NULL', label: 'Está vazio' },
    { value: 'IS_NOT_NULL', label: 'Não está vazio' }
  ],
  datetime: [
    { value: 'EQUALS', label: 'É em' },
    { value: 'NOT_EQUALS', label: 'Não é em' },
    { value: 'BEFORE', label: 'É antes de' },
    { value: 'AFTER', label: 'É depois de' },
    { value: 'BETWEEN', label: 'Está entre' },
    { value: 'IS_NULL', label: 'Está vazio' },
    { value: 'IS_NOT_NULL', label: 'Não está vazio' }
  ],
  boolean: [
    { value: 'EQUALS', label: 'É igual a' },
    { value: 'NOT_EQUALS', label: 'Diferente de' }
  ],
  duration: [
    { value: 'EQUALS', label: 'Igual a' },
    { value: 'NOT_EQUALS', label: 'Diferente de' },
    { value: 'GREATER_THAN', label: 'Maior que' },
    { value: 'GREATER_THAN_OR_EQUAL', label: 'Maior ou igual a' },
    { value: 'LESS_THAN', label: 'Menor que' },
    { value: 'LESS_THAN_OR_EQUAL', label: 'Menor ou igual a' },
    { value: 'IS_NULL', label: 'Está vazio' },
    { value: 'IS_NOT_NULL', label: 'Não está vazio' }
  ],
  // Operadores específicos para campos enum (Status, Prioridade, Canal de Origem)
  enum: [
    { value: 'EQUALS', label: 'Igual a' },
    { value: 'NOT_EQUALS', label: 'Diferente de' }
  ],
  // Operadores específicos para campos com join
  join: [
    { value: 'EQUALS', label: 'Igual a' },
    { value: 'NOT_EQUALS', label: 'Diferente de' },
    { value: 'IS_NULL', label: 'Está vazio' },
    { value: 'IS_NOT_NULL', label: 'Não está vazio' }
  ]
};

// Report frequency options
export const REPORT_FREQUENCY = [
  { value: 'DAILY', label: 'Diário' },
  { value: 'WEEKLY', label: 'Semanal' },
  { value: 'MONTHLY', label: 'Mensal' }
];

// Days of week for weekly scheduling (1-7, where 1=Monday)
export const DAYS_OF_WEEK = [
  { value: 1, label: 'Segunda-feira' },
  { value: 2, label: 'Terça-feira' },
  { value: 3, label: 'Quarta-feira' },
  { value: 4, label: 'Quinta-feira' },
  { value: 5, label: 'Sexta-feira' },
  { value: 6, label: 'Sábado' },
  { value: 7, label: 'Domingo' }
];

// Days of month for monthly scheduling (1-31)
export const DAYS_OF_MONTH = Array.from({ length: 31 }, (_, i) => ({
  value: i + 1,
  label: `${i + 1}${i === 0 ? 'º' : i === 1 ? 'º' : i === 2 ? 'º' : 'º'}`
}));

// Condition types for filters
export const CONDITION_TYPES = [
  { value: 'AND', label: 'E (AND)' },
  { value: 'OR', label: 'OU (OR)' }
];

// Função utilitária para obter operadores baseado no tipo de campo
export const getFieldOperators = field => {
  // Se é um campo enum, retorna operadores específicos para enum
  if (field.isEnum) {
    return FIELD_OPERATORS.enum;
  }

  // Se tem join mas não é enum, retorna operadores específicos para join
  if (field.hasJoin && !field.isEnum) {
    return FIELD_OPERATORS.join;
  }

  // Caso contrário, retorna operadores baseados no dataType
  return FIELD_OPERATORS[field.dataType] || FIELD_OPERATORS.text;
};
